import { useInitiateOrderMutation } from "src/store/apis/Flights";
import { transformIntoFlightsOrder } from "../utils";
import { useJourneyDynamicDetails, useJourneyStaticDetails } from "../../../context";
import { BookingFlags, Payment } from "../constants";
import { simpleHash } from "src/utility";
import appConfig from "src/app.config";
import { useParams } from "react-router-dom";

export function hasBookingFlags(data: any): boolean {
  if (!data) return false;
  const { changeInItinerary, ssrDenied } = data;
  return !!(
    changeInItinerary?.isPriceChanged ||
    changeInItinerary?.isArrivalTimeChanged ||
    changeInItinerary?.isDepartureTimeChanged ||
    ssrDenied
  );
}

export function computeBookingFlags(data: any, error: unknown): BookingFlags {
  return {
    isPriceChanged: data?.changeInItinerary?.isPriceChanged,
    isArrivalTimeChanged: data?.changeInItinerary?.isArrivalTimeChanged,
    isDepartureTimeChanged: data?.changeInItinerary?.isDepartureTimeChanged,
    isSSRDenied: data?.ssrDenied,
    bookingFailed: (data && !data.orderId) || !!error,
  };
}

export function useInitiateOrder() {
  const [triggerInitiate, { isLoading }] = useInitiateOrderMutation();
  const { passengersState } = useJourneyDynamicDetails();
  const [passengers] = passengersState;
  const { journeySearchData, journeyDetails } = useJourneyStaticDetails();
  const { journeyId } = journeySearchData;
  const {ticketId} = useParams();

  const runInitiate = async (selectedPayment: Payment) => {
    const returnUrl = `${appConfig.REACT_APP_DEPLOYMENT_URL}travel/ticket-result/${ticketId}?fromPayment=true`;
    return await triggerInitiate(transformIntoFlightsOrder(journeyId, passengers.passengers, selectedPayment.cash, returnUrl))
  };

  return {
    isLoading,
    runInitiate,
    refetchDetails: journeyDetails.refetch,
  };
}